<template>
  <div class="information">
    <topNav></topNav>
    <div class="content">
    <div class="demobox banner" v-if="banners.length>0">
      <el-carousel trigger="click" class="bannerMain" v-show="banners.length>1">
        <el-carousel-item v-for="(item,index) in banners" :key="index">
          <div class="bannerimg">
            <img :src="item" class="bannerimg" alt="" />
          </div>
        </el-carousel-item>
      </el-carousel>
      <img :src="banners[0]" v-show="banners.length<=1" class="bannerimg" alt="" />
    </div>
      <div class="intro">
        <div
          @click="checkedIntro(0)"
          class="introTitle introTitleM"
          :id="introIndex == 0 ? 'introTitle' : ''"
        >
          {{ list[0].name }}
        </div>
        <div style="width: 200px"></div>
        <div
          @click="checkedIntro(1)"
          class="introTitle"
          :id="introIndex == 1 ? 'introTitle' : ''"
        >
          {{ list[1].name }}
        </div>
        <div class="introBorder"></div>
      </div>

      <!-- 德讯观市 -->
      <div class="right" v-if="introIndex == 0">
        <div
          class="card"
          v-for="item in needDataDXGS"
          :key="item.time"
          @click="toDetail(item.id)"
        >
          <div class="cardTime">
            <div class="cardTime1"></div>
            <div class="cardTime3">{{ item.published }}</div>
          </div>
          <img class="cardImg" :src="item.img" alt="" />
          <!-- <div class="cardImg" :style="{backgroundImage:'url('+item.url+')'}"></div> -->
          <div class="cardTitle">{{ item.title }}</div>
        </div>
      </div>
      <div class="zlpage" v-if="introIndex == 0">
        <el-pagination
          v-if="showpag"
          id="FY"
          @mouseleave="leave()"
          background
          prev-text="上一页"
          next-text="下一页"
          layout="prev, pager, next"
          :total="totalDXGS"
          :page-size="16"
          @current-change="currentChangeHandle"
          :current-page="currentPageDXGS"
        >
        </el-pagination>
      </div>
      <!-- 市场动态 -->
      <div class="right" v-if="introIndex == 1">
        <div
          class="card"
          v-for="item in needDataSCDT"
          :key="item.time"
          @click="toDetail(item.id)"
        >
          <div class="cardTime">
            <div class="cardTime1"></div>
            <div class="cardTime3">{{ item.published }}</div>
          </div>
          <img class="cardImg" :src="item.img" alt="" />

          <!-- <div class="cardImg" :style="{backgroundImage:'url('+item.url+')'}"></div> -->
          <div class="cardTitle">{{ item.title }}</div>
        </div>
      </div>
      <div class="zlpage" v-if="introIndex == 1">
        <el-pagination
          v-if="showpag1"
          id="FY"
          @mouseleave="leave()"
          background
          prev-text="上一页"
          next-text="下一页"
          layout="prev, pager, next"
          :total="totalSCDT"
          :page-size="16"
          @current-change="currentChangeHandle_SCDT"
          :current-page="currentPageSCDT"
        >
        </el-pagination>
      </div>
    </div>
    <Bottoms></Bottoms>
  </div>
</template>
<script>
import topNav from "./sub/topNav";
import Bottoms from "./sub/Bottoms";
import { colunmList,productList,columnTypeList } from "@/api/topNav.js";
import { l } from "@/utils/tool";
export default {
  name: "information",
  components: { topNav, Bottoms },
  data() {
    return {
      banners:[],
      showpag: false,
      showpag1: false,
      list: [
        { name: "", id: "" },
        { name: "", id: "" },
      ],
      introIndex: 0,
      showListDXGS: [
        {
          url: require("../common/images/information/checked.png"),
          time: "2021-09-14",
          title: "稳中求进  守正创新丨德讯22岁生日快乐",
          intro:
            "今天是个特别的日子，是勇者积极开拓、厚积薄发的胜利日，是强者坚韧不拔、自强不息的纪念日，德讯在党的领导下，迎来了22周年生日。",
        },
        {
          url: require("../common/images/information/002.png"),
          time: "2021-08-24",
          title: "军旅文化丨致敬最可爱的人",
          intro:
            "公司在建军节之际，开展德讯证顾军旅文化启动大会，以此致敬最可爱的人！与此同时，也进一步推动公司军旅文化建设，打造凝聚力强......",
        },
        {
          url: require("../common/images/information/003.png"),
          time: "2020-04-14",
          title: "活动回顾丨风起扬帆，行稳致远",
          intro:
            "2020年7月，公司21周年庆典暨入职周年记活动成功举办，此次活动在总结过去工作经验的同时，也进一步明确未来的奋斗目标与方向......",
        },
        {
          url: require("../common/images/information/004.png"),
          time: "2020-07-21",
          title: "十月生日会丨弘志毅行，筑梦青春",
          intro: "小小的心意  承载着浓浓的关怀",
        },
        {
          url: require("../common/images/information/001.png"),
          time: "2021-07-24",
          title: "稳中求进  守正创新丨德讯22岁生日快乐",
          intro:
            "今天是个特别的日子，是勇者积极开拓、厚积薄发的胜利日，是强者坚韧不拔、自强不息的纪念日，德讯在党的领导下，迎来了22周年生日。",
        },
        {
          url: require("../common/images/information/002.png"),
          time: "2021-08-04",
          title: "军旅文化丨致敬最可爱的人",
          intro:
            "公司在建军节之际，开展德讯证顾军旅文化启动大会，以此致敬最可爱的人！与此同时，也进一步推动公司军旅文化建设，打造凝聚力强......",
        },
        {
          url: require("../common/images/information/003.png"),
          time: "2020-07-14",
          title: "活动回顾丨风起扬帆，行稳致远",
          intro:
            "2020年7月，公司21周年庆典暨入职周年记活动成功举办，此次活动在总结过去工作经验的同时，也进一步明确未来的奋斗目标与方向......",
        },
        {
          url: require("../common/images/information/004.png"),
          time: "2020-01-11",
          title: "十月生日会丨弘志毅行，筑梦青春",
          intro: "小小的心意  承载着浓浓的关怀",
        },
        {
          url: require("../common/images/information/001.png"),
          time: "2021-07-14",
          title: "稳中求进  守正创新丨德讯22岁生日快乐",
          intro:
            "今天是个特别的日子，是勇者积极开拓、厚积薄发的胜利日，是强者坚韧不拔、自强不息的纪念日，德讯在党的领导下，迎来了22周年生日。",
        },
        {
          url: require("../common/images/information/002.png"),
          time: "2021-08-14",
          title: "军旅文化丨致敬最可爱的人",
          intro:
            "公司在建军节之际，开展德讯证顾军旅文化启动大会，以此致敬最可爱的人！与此同时，也进一步推动公司军旅文化建设，打造凝聚力强......",
        },
        {
          url: require("../common/images/information/003.png"),
          time: "2020-02-10",
          title: "活动回顾丨风起扬帆，行稳致远",
          intro:
            "2020年7月，公司21周年庆典暨入职周年记活动成功举办，此次活动在总结过去工作经验的同时，也进一步明确未来的奋斗目标与方向......",
        },
        {
          url: require("../common/images/information/004.png"),
          time: "2020-08-07",
          title: "十月生日会丨弘志毅行，筑梦青春",
          intro: "小小的心意  承载着浓浓的关怀",
        },
        {
          url: require("../common/images/information/004.png"),
          time: "2021-08-02",
          title: "十月生日会丨弘志毅行，筑梦青春",
          intro: "小小的心意  承载着浓浓的关怀",
        },
        {
          url: require("../common/images/information/004.png"),
          time: "2022-08-31",
          title: "十月生日会丨弘志毅行，筑梦青春",
          intro: "小小的心意  承载着浓浓的关怀",
        },
        {
          url: require("../common/images/information/003.png"),
          time: "2020-02-21",
          title: "活动回顾丨风起扬帆，行稳致远",
          intro:
            "2020年7月，公司21周年庆典暨入职周年记活动成功举办，此次活动在总结过去工作经验的同时，也进一步明确未来的奋斗目标与方向......",
        },
        {
          url: require("../common/images/information/004.png"),
          time: "2020-08-13",
          title: "十月生日会丨弘志毅行，筑梦青春",
          intro: "小小的心意  承载着浓浓的关怀",
        },
        {
          url: require("../common/images/information/003.png"),
          time: "2020-02-22",
          title: "活动回顾丨风起扬帆，行稳致远",
          intro:
            "2020年7月，公司21周年庆典暨入职周年记活动成功举办，此次活动在总结过去工作经验的同时，也进一步明确未来的奋斗目标与方向......",
        },
        {
          url: require("../common/images/information/004.png"),
          time: "2020-08-30",
          title: "十月生日会丨弘志毅行，筑梦青春",
          intro: "小小的心意  承载着浓浓的关怀",
        },
      ],
      showListSCDT: [
        {
          url: require("../common/images/information/003.png"),
          time: "2020-02-10",
          title: "活动回顾丨风起扬帆，行稳致远",
          intro:
            "2020年7月，公司21周年庆典暨入职周年记活动成功举办，此次活动在总结过去工作经验的同时，也进一步明确未来的奋斗目标与方向......",
        },
        {
          url: require("../common/images/information/004.png"),
          time: "2020-08-07",
          title: "十月生日会丨弘志毅行，筑梦青春",
          intro: "小小的心意  承载着浓浓的关怀",
        },
        {
          url: require("../common/images/information/004.png"),
          time: "2021-08-02",
          title: "十月生日会丨弘志毅行，筑梦青春",
          intro: "小小的心意  承载着浓浓的关怀",
        },
        {
          url: require("../common/images/information/004.png"),
          time: "2022-08-31",
          title: "十月生日会丨弘志毅行，筑梦青春",
          intro: "小小的心意  承载着浓浓的关怀",
        },
        {
          url: require("../common/images/information/003.png"),
          time: "2020-02-21",
          title: "活动回顾丨风起扬帆，行稳致远",
          intro:
            "2020年7月，公司21周年庆典暨入职周年记活动成功举办，此次活动在总结过去工作经验的同时，也进一步明确未来的奋斗目标与方向......",
        },
        {
          url: require("../common/images/information/004.png"),
          time: "2020-08-13",
          title: "十月生日会丨弘志毅行，筑梦青春",
          intro: "小小的心意  承载着浓浓的关怀",
        },
        {
          url: require("../common/images/information/003.png"),
          time: "2020-02-22",
          title: "活动回顾丨风起扬帆，行稳致远",
          intro:
            "2020年7月，公司21周年庆典暨入职周年记活动成功举办，此次活动在总结过去工作经验的同时，也进一步明确未来的奋斗目标与方向......",
        },
        {
          url: require("../common/images/information/004.png"),
          time: "2020-08-30",
          title: "十月生日会丨弘志毅行，筑梦青春",
          intro: "小小的心意  承载着浓浓的关怀",
        },
        {
          url: require("../common/images/information/001.png"),
          time: "2021-09-14",
          title: "稳中求进  守正创新丨德讯22岁生日快乐",
          intro:
            "今天是个特别的日子，是勇者积极开拓、厚积薄发的胜利日，是强者坚韧不拔、自强不息的纪念日，德讯在党的领导下，迎来了22周年生日。",
        },
        {
          url: require("../common/images/information/002.png"),
          time: "2021-08-24",
          title: "军旅文化丨致敬最可爱的人",
          intro:
            "公司在建军节之际，开展德讯证顾军旅文化启动大会，以此致敬最可爱的人！与此同时，也进一步推动公司军旅文化建设，打造凝聚力强......",
        },
        {
          url: require("../common/images/information/003.png"),
          time: "2020-04-14",
          title: "活动回顾丨风起扬帆，行稳致远",
          intro:
            "2020年7月，公司21周年庆典暨入职周年记活动成功举办，此次活动在总结过去工作经验的同时，也进一步明确未来的奋斗目标与方向......",
        },
        {
          url: require("../common/images/information/004.png"),
          time: "2020-07-21",
          title: "十月生日会丨弘志毅行，筑梦青春",
          intro: "小小的心意  承载着浓浓的关怀",
        },
        {
          url: require("../common/images/information/001.png"),
          time: "2021-07-24",
          title: "稳中求进  守正创新丨德讯22岁生日快乐",
          intro:
            "今天是个特别的日子，是勇者积极开拓、厚积薄发的胜利日，是强者坚韧不拔、自强不息的纪念日，德讯在党的领导下，迎来了22周年生日。",
        },
        {
          url: require("../common/images/information/002.png"),
          time: "2021-08-04",
          title: "军旅文化丨致敬最可爱的人",
          intro:
            "公司在建军节之际，开展德讯证顾军旅文化启动大会，以此致敬最可爱的人！与此同时，也进一步推动公司军旅文化建设，打造凝聚力强......",
        },
        {
          url: require("../common/images/information/003.png"),
          time: "2020-07-14",
          title: "活动回顾丨风起扬帆，行稳致远",
          intro:
            "2020年7月，公司21周年庆典暨入职周年记活动成功举办，此次活动在总结过去工作经验的同时，也进一步明确未来的奋斗目标与方向......",
        },
        {
          url: require("../common/images/information/004.png"),
          time: "2020-01-11",
          title: "十月生日会丨弘志毅行，筑梦青春",
          intro: "小小的心意  承载着浓浓的关怀",
        },
        {
          url: require("../common/images/information/001.png"),
          time: "2021-07-14",
          title: "稳中求进  守正创新丨德讯22岁生日快乐",
          intro:
            "今天是个特别的日子，是勇者积极开拓、厚积薄发的胜利日，是强者坚韧不拔、自强不息的纪念日，德讯在党的领导下，迎来了22周年生日。",
        },
        {
          url: require("../common/images/information/002.png"),
          time: "2021-08-14",
          title: "军旅文化丨致敬最可爱的人",
          intro:
            "公司在建军节之际，开展德讯证顾军旅文化启动大会，以此致敬最可爱的人！与此同时，也进一步推动公司军旅文化建设，打造凝聚力强......",
        },
      ],
      currentPageDXGS: 1, //初始页
      totalDXGS: "", //文章数量
      currentPageSCDT: 1, //初始页
      totalSCDT: "", //文章数量

      needDataDXGS: [],
      needDataSCDT: [],
      pages: {
        current: 1,
        total: 100,
        size: 16,
      },
    };
  },
  mounted() {
    this.selectf();
    window.scrollTo(0, 0);
    var index = this.$route.query.index;
    if (index == 1) {
      this.introIndex = 0;
    } else if (index == 2) {
      this.introIndex = 1;
    }
    var information = localStorage.getItem("information")
      ? localStorage.getItem("information")
      : "xxxx";
    if (information != "xxxx") {
      var json = JSON.parse(information);
      if (json.showHistory == 3) {
        this.introIndex = json.introIndex;
        if (json.introIndex == 0) {
          this.currentPageDXGS = json.page;
        } else {
          this.currentPageSCDT = json.page;
        }
      }
      json.showHistory = 1;
      var obj = JSON.stringify(json);
      localStorage.setItem("information", obj);
    }

    this.initfun();
    // this.getlistDXGS();
    // this.getlistSCDT();
  },

  methods: {
    // 初始化
    getDataDXGG: function (page, limit, id) {
      this.$api.viewZXList(page, limit, id).then((res) => {
        this.needDataDXGS = res.data.list;
        this.totalDXGS = res.data.total;
        this.needDataDXGS.map(function (item) {
          item.published = item.published.split(" ")[0];
        });
        this.showpag = true;
      });
      window.scrollTo(0, 0);
    },
    getDataSCDT: function (page, limit, id) {
      this.$api.viewZXList(page, limit, id).then((res) => {
        this.needDataSCDT = res.data.list;
        this.totalSCDT = res.data.total;

        this.needDataSCDT.map(function (item) {
          item.published = item.published.split(" ")[0];
        });
        this.showpag1 = true;
        // this.getlistSCDT();
      });
      window.scrollTo(0, 0);
    },
    initfun: function () {
      this.$api.viewZXZX().then((res) => {
        if (res.code == 0) {
          this.list = res.data.list;
          this.getDataDXGG(this.currentPageDXGS, 16, res.data.list[0].id);
          this.getDataSCDT(this.currentPageSCDT, 16, res.data.list[1].id);
        } else {
          alert("获取失败");
        }
      });
    },

    checkedIntro: function (item) {
      this.introIndex = item;
    },
    //  getlistDXGS: function () {
    //     var data = this.showListDXGS;
    //   var currentPageDXGS = this.currentPageDXGS;
    //   var result = [];
    //   for (var i = 0, len = data.length; i < len; i += 16) {
    //     result.push(data.slice(i, i + 16));
    //   }
    //   console.log("分割后的数据", result);
    //   this.needDataDXGS = result[currentPageDXGS - 1];
    // },
    // getlistSCDT: function () {
    //     var data = this.showListSCDT;
    //   var currentPageSCDT = this.currentPageSCDT;
    //   var result = [];
    //   for (var i = 0, len = data.length; i < len; i += 16) {
    //     result.push(data.slice(i, i + 16));
    //   }
    //   console.log("分割后的数据", result);
    //   this.needDataSCDT = result[currentPageSCDT - 1];
    // },
    pagefun: function (p) {
      console.log(p);
    },
    toDetail: function (a) {
      var thisItem = this.introIndex;
      var lanMu = this.list[thisItem].id;
      var thisPage =
        this.introIndex == 0 ? this.currentPageDXGS : this.currentPageSCDT;
      var information = {
        showHistory: 2,
        introIndex: this.introIndex,
        page: thisPage,
      };
      var json = JSON.stringify(information);
      localStorage.setItem("information", json);
      // this.$router.push('informatDetail')
      this.$router.push({
        name: "informatDetail",
        query: {
          id: a,
        },
      });
    },

    // 分頁
    currentChangeHandle(val) {
      this.currentPageDXGS = val;
      this.getDataDXGG(val, 16, this.list[0].id);
    },
    currentChangeHandle_SCDT(val) {
      this.currentPageSCDT = val;
      this.getDataSCDT(val, 16, this.list[1].id);
    },
    selectf(){
        colunmList({ column_name:'必读资讯' }).then((res) => { //产品管理列表
        //列表
        if (res.code == 200 && res.data.list) {
          if(res.data.list[0].pictures){
          this.banners = res.data.list[0].pictures.split(',');
          // l(this.banners,'图片');
          }

        }
      });
    }
  },
};
</script>
<style scoped>
.bannerMain >>> .el-carousel__container {
  width: 100%;
  height: 400px !important;
}
.information {
  background-color: #f4f4f4;
  width: 100%;
      max-width: 1920px;
    position: relative;
    margin: auto;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    overflow: hidden;

}
.content {
  /* display: flex; */
  /* width: 996px; */
  /* margin: 20px auto 0; */
}

/* 选择 */
.intro {
  position: relative;
  box-sizing: border-box;
  display: flex;
  width: 1340px;
  height: 90px;
  font-size: 28px;
  font-family: PingFang SC;
  font-weight: 400;
  line-height: 48px;
  color: #888888;
  opacity: 1;
  margin: 0px auto 0px;
  padding: 20px 0px;
}
.introTitleM {
  margin-left: 166px;
}
.introTitle {
  position: relative;
  z-index: 9;
  width: 400px;
  height: 50px;
  cursor: pointer;
}
#introTitle {
  border-bottom: 2px solid #e7413b;
  color: #e7413b;
  font-weight: bold;
}
.introBorder {
  position: absolute;
  top: 70px;
  left: 0px;
  width: 1340px;
  height: 1px;
  background-color: #d2d2d2;
}

/* 右边内容 */
.right {
  display: flex;
  /* justify-content: space-between; */
  align-content: flex-start;
  flex-wrap: wrap;
  width: 1336px;
  margin: 0 auto;
}
.card {
  cursor: pointer;
  box-sizing: border-box;
  position: relative;
  width: 320px;
  height: 308px;
  opacity: 1;
  background-color: #fff;
  margin: 0px 7px 20px 7px;
}
.card:hover .cardTitle {
  color: #e7413b;
}
.cardTime {
  position: absolute;
  display: flex;
  top: 265px;
  left: -10px;
  width: 205px;
  height: 46px;
}
.cardTime1 {
  width: 14px;
  height: 14px;
  background: url("../common/images/information/date.png") no-repeat;
  background-size: 100% 100%;
  margin: 16px 10px 0px 22px;
}

.cardTime3 {
  height: 20px;
  font-size: 14px;
  font-family: PingFang SC;
  font-weight: 400;
  line-height: 22px;
  color: #999;
  opacity: 1;
  margin: 12px 0px 0px 0px;
}
.cardImg {
  width: 320px;
  height: 190px;
  background-size: 100% 100%;
}
.cardTitle {
  box-sizing: border-box;
  width: 320px;
  padding: 0 12px;
  margin-top: 10px;
  font-size: 24px;
  font-family: PingFang SC;
  font-weight: bold;
  line-height: 32px;
  color: #333333;
  opacity: 1;
  text-align: left;
 overflow:hidden;

text-overflow:ellipsis;

display:-webkit-box;

-webkit-box-orient:vertical;

-webkit-line-clamp:2; 
}

.zlpage {
  margin: 20px auto 60px;
}
#FY /deep/ .el-pager .number {
  border-radius: 4px;
}
#FY /deep/ .el-pager .active {
  background-color: #e7413b;
}
#FY /deep/ .el-pager .number:not(.active):hover {
  color: #666;
}
.bannerMain {
  width: 100%;
  height: 100%;
}
.bannerimg {
  display: block;
  width: 100%;
  max-width: 1920px;
  height: 400px;
  margin: auto;
  position: relative;
}
</style>


// WEBPACK FOOTER //
// src/components/information.vue